var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xu-qiu-lei-bie"},[_c('dv-border-box-11',{attrs:{"title":"各类质量服务需求市场体量预计（单位：万元）","titleWidth":450}},[_c('div',{ref:"xu_qiu_lei_bie_echarts",staticClass:"xu-qiu-lei-bie-container"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }